import React from "react";
import ReactDOM from "react-dom/client";
//
import { Provider } from "react-redux";
import store from "./store";
// STYLE
import "./styles/index.scss";
import "./index.css";
import "./fonts/line-awesome-1.3.0/css/line-awesome.css";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import ReactGA from "react-ga4";
//
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// Initialize Google Analytics with your tracking ID
ReactGA.initialize("G-X6XL920VPQ");

// Send initial pageview
ReactGA.send({
  hitType: "pageview",
  page: window.location.pathname + window.location.search,
  title: document.title,
});

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
